import * as types from './types';
import applicationFlowTypes from '../../constants/application-flow-types';

export const setSummaryLoading = (isLoading = false) => ({
  type: types.VACANCY_SET_SUMMARY_LOADING,
  isLoading
});

export const setFormLoading = (isLoading = false) => ({
  type: types.VACANCY_SET_FORM_LOADING,
  isLoading
});

export const setQuestionsLoading = (isLoading = false, part) => ({
  type: types.VACANCY_SET_QUESTIONS_LOADING,
  isLoading,
  part
});

export const setApplicationsLoading = (isLoading = false) => ({
  type: types.VACANCY_SET_APPLICATIONS_LOADING,
  isLoading
});

export const setPublicPrescreeningQuestionsLoading = (
  isLoading = false,
  part
) => ({
  type: types.VACANCY_SET_PUBLIC_PRESCREENING_QUESTIONS_LOADING,
  isLoading
});

export const setQuestionAdding = (isLoading = false, questionType) => ({
  type: types.VACANCY_SET_QUESTION_ADDING,
  isLoading,
  questionType
});

export const setQuestionDeleting = (isLoading = false, questionType) => ({
  type: types.VACANCY_SET_QUESTION_DELETING,
  isLoading,
  questionType
});

export const setVacancyPosting = (isLoading = false) => ({
  type: types.VACANCY_SET_VACANCY_POSTING,
  isLoading
});

export const setVacancyPuttingOnHold = (isLoading = false) => ({
  type: types.VACANCY_SET_VACANCY_PUTTING_ON_HOLD,
  isLoading
});

export const setVacancyRePosting = (isLoading = false) => ({
  type: types.VACANCY_SET_VACANCY_RE_POSTING,
  isLoading
});

export const setVacancyArchiving = (isLoading = false) => ({
  type: types.VACANCY_SET_VACANCY_ARCHIVING,
  isLoading
});

export const addVacancyQuestion = (
  schoolId,
  vacancyId,
  questionType,
  question
) => ({
  type: types.VACANCY_ADD_QUESTION,
  schoolId,
  vacancyId,
  questionType,
  question
});

export const addVacancy = (vacancy, saveType = 'draft', duplicate) => ({
  type: types.VACANCIES_ADD_VACANCY,
  vacancy,
  saveType,
  duplicate
});

export const removeVacancyQuestion = (
  schoolId,
  vacancyId,
  questionType,
  questionId
) => ({
  type: types.VACANCY_REMOVE_QUESTION,
  schoolId,
  vacancyId,
  questionType,
  questionId
});

export const getVacancyQuestions = (schoolId, vacancyId, questionsType) => ({
  type: types.VACANCY_GET_QUESTIONS,
  schoolId,
  vacancyId,
  questionsType
});

export const getPublicVacancyPrescreeningQuestions = (schoolId, vacancyId) => ({
  type: types.VACANCY_GET_PUBLIC_PRESCREENING_QUESTIONS,
  schoolId,
  vacancyId
});

export const setPublicVacancyPrescreeningQuestions = questions => ({
  type: types.VACANCY_SET_PUBLIC_PRESCREENING_QUESTIONS,
  questions
});

export const resetPublicVacancyPrescreeningQuestions = () => ({
  type: types.VACANCY_RESET_PUBLIC_PRESCREENING_QUESTIONS
});

export const createPublicVacancyApplication = (
  schoolId,
  vacancyId,
  applicationFlowType = applicationFlowTypes.fromLoggedUser,
  data = null,
  vacancyDiscoverySourceId = null
) => ({
  type: types.VACANCY_CREATE_PUBLIC_APPLICATION,
  schoolId,
  vacancyId,
  applicationFlowType,
  data,
  vacancyDiscoverySourceId
});

export const setApplicationErrors = (errors = null) => ({
  type: types.VACANCY_SET_PUBLIC_APPLICATION_ERRORS,
  errors
});

export const setApplicationStatus = (status = null) => ({
  type: types.VACANCY_SET_PUBLIC_APPLICATION_STATUS,
  status
});

export const getPublicVacancyApplication = (schoolId, vacancyId) => ({
  type: types.VACANCY_GET_PUBLIC_APPLICATION,
  schoolId,
  vacancyId
});

export const setPublicVacancyApplicationLoading = isLoading => ({
  type: types.VACANCY_SET_PUBLIC_APPLICATION_LOADING,
  isLoading
});

export const setPublicVacancyApplication = (
  applicationId = null,
  applicationFlowType = applicationFlowTypes.fromLoggedUser
) => ({
  type: types.VACANCY_SET_PUBLIC_APPLICATION,
  applicationId,
  applicationFlowType
});

export const resetPublicVacancyApplication = () => ({
  type: types.VACANCY_RESET_PUBLIC_APPLICATION
});

export const setVacancyQuestions = (questions, questionsType) => ({
  type: types.VACANCY_SET_QUESTIONS,
  questions,
  questionsType
});

export const resetVacancyQuestions = () => ({
  type: types.VACANCY_RESET_QUESTIONS
});

export const getVacancySummary = (schoolId, vacancyId) => ({
  type: types.VACANCY_GET_SUMMARY,
  schoolId,
  vacancyId
});

export const setVacancySummary = vacancySummary => ({
  type: types.VACANCY_SET_SUMMARY,
  vacancySummary
});

export const resetVacancySummary = () => ({
  type: types.VACANCY_RESET_SUMMARY
});

export const updateVacancySummary = vacancySummary => ({
  type: types.VACANCIES_UPDATE_SUMMARY,
  vacancySummary
});

export const getVacancyApplications = (schoolId, vacancyId, queryParams) => ({
  type: types.VACANCY_GET_APPLICATIONS,
  schoolId,
  vacancyId,
  queryParams
});

export const setVacancyApplications = vacancyApplications => ({
  type: types.VACANCY_SET_APPLICATIONS,
  vacancyApplications
});

export const resetVacancyApplications = () => ({
  type: types.VACANCY_RESET_APPLICATIONS
});

export const setVacancySummaryError = error => ({
  type: types.VACANCY_SET_SUMMARY_ERROR,
  error
});

export const postVacancy = (schoolId, vacancyId) => ({
  type: types.VACANCIES_POST_VACANCY,
  schoolId,
  vacancyId
});

export const putVacancyOnHold = (schoolId, putVacancyOnHoldRequest) => ({
  type: types.VACANCIES_PUT_ON_HOLD_VACANCY,
  schoolId,
  putVacancyOnHoldRequest
});

export const rePostVacancy = (schoolId, rePostVacancyRequest) => ({
  type: types.VACANCIES_RE_POST_VACANCY,
  schoolId,
  rePostVacancyRequest
});

export const archiveVacancy = (schoolId, vacancyId) => ({
  type: types.VACANCIES_ARCHIVE_VACANCY,
  schoolId,
  vacancyId
});

export const setVacancyApplicationsQueryParams = queryParams => ({
  type: types.VACANCY_SET_APPLICATIONS_QUERY_PARAMS,
  queryParams
});

export const setVacancySelectedApplicationIds = selectedApplicationIds => ({
  type: types.VACANCY_SET_SELECTED_APPLICATION_IDS,
  selectedApplicationIds
});

export const setVacancyKeepingPosted = isLoading => ({
  type: types.VACANCIES_SET_VACANCY_KEEPING_POSTED,
  isLoading
});

export const keepVacancyPosted = (
  schoolId,
  vacancyId,
  keepVacancyPostedRequest
) => ({
  type: types.VACANCIES_KEEP_POSTED_VACANCY,
  schoolId,
  vacancyId,
  keepVacancyPostedRequest
});

export const setVacancyRemainingOnHold = isLoading => ({
  type: types.VACANCIES_SET_VACANCY_REMAINING_ON_HOLD,
  isLoading
});

export const remainVacancyOnHold = (
  schoolId,
  vacancyId,
  remainVacancyOnHoldRequest
) => ({
  type: types.VACANCIES_REMAIN_ON_HOLD_VACANCY,
  schoolId,
  vacancyId,
  remainVacancyOnHoldRequest
});

export const getDataForDuplicateVacancy = (schoolId, vacancyId) => ({
  type: types.VACANCIES_GET_DATA_FOR_DUPLICATE_VACANCY,
  schoolId,
  vacancyId
});

export const setVacancyDuplicationFormDataLoading = isVacancyDuplicationFormDataLoading => ({
  type: types.VACANCY_SET_VACANCY_DUPLICATION_FORM_DATA_LOADING,
  isVacancyDuplicationFormDataLoading
});

export const setDuplicatedVacancy = duplicatedVacancy => ({
  type: types.VACANCY_SET_DUPLICATED_VACANCY,
  duplicatedVacancy
});

export const resetVacancyDuplicationState = () => ({
  type: types.VACANCY_RESET_VACANCY_DUPLICATION_STATE
});

export const setDuplicatedVacancyHasBeenPosted = duplicatedVacancyHasBeenPosted => ({
  type: types.VACANCY_SET_DUPLICATED_VACANCY_HAS_BEEN_POSTED,
  duplicatedVacancyHasBeenPosted
});

export const setNotHiredApplicationsToInviteToDuplicatedVacancy = notHiredApplicationsToInvite => ({
  type:
    types.VACANCY_SET_NOT_HIRED_APPLICATIONS_TO_INVITE_TO_DUPLICATED_VACANCY,
  notHiredApplicationsToInvite
});

export const getNotHiredApplicationsToInviteToDuplicatedVacancy = (
  schoolId,
  vacancyId
) => ({
  type:
    types.VACANCY_GET_NOT_HIRED_APPLICATIONS_TO_INVITE_TO_DUPLICATED_VACANCY,
  schoolId,
  vacancyId
});

export const setDuplicatedVacancyReferenceData = (schoolId, vacancyId) => ({
  type: types.VACANCY_SET_DUPLICATED_VACANCY_REFERENCE_DATA,
  schoolId,
  vacancyId
});

export const setInvitingPriorCandidates = isInvitingPriorCandidates => ({
  type: types.SCHOOL_VACANCY_INVITATIONS_SET_INVITING_PRIOR_CANDIDATES,
  isInvitingPriorCandidates
});

export const sendPriorCandidatesInvitations = (
  schoolId,
  invitationVacancyId,
  invitations,
  onSubmitted
) => ({
  type: types.SCHOOL_SEND_PRIOR_CANDIDATES_INVITATIONS,
  schoolId,
  invitationVacancyId,
  invitations,
  onSubmitted
});

export const setInvitingByEmails = isInvitingByEmails => ({
  type: types.SCHOOL_VACANCY_INVITATIONS_SET_INVITING_BY_EMAILS,
  isInvitingByEmails
});

export const deleteDraftVacancy = (schoolId, vacancyId) => ({
  type: types.VACANCIES_DELETE_DRAFT_VACANCY,
  schoolId,
  vacancyId
});
export const setDraftVacancyDeleting = isLoading => ({
  type: types.VACANCIES_SET_DRAFT_VACANCY_DELETING,
  isLoading
});

export const sendByEmailsInvitations = (
  schoolId,
  invitationVacancyId,
  invitations,
  onSubmitted
) => ({
  type: types.SCHOOL_SEND_BY_EMAILS_INVITATIONS,
  schoolId,
  invitationVacancyId,
  invitations,
  onSubmitted
});

export const setVacancyApplicationsPrintVersionIsLoading = printVersionIsLoading => ({
  type: types.VACANCIES_SET_PRINT_VERSION_IS_LOADING,
  printVersionIsLoading
});

export const printVacancyApplications = (
  url,
  selectedApplicationIds,
  printOptions
) => ({
  type: types.VACANCIES_PRINT_VACANCY_APPLICATIONS,
  url,
  selectedApplicationIds,
  printOptions
});



// WEBPACK FOOTER //
// ./src/actions/vacancies/index.js